// extracted by mini-css-extract-plugin
module.exports = {"Title":"Title_Title__JOL44"};